import {
  CustomAutocomplete, CustomAutocompleteArrString, CustomTextArea,
  CustomTextField, LoaderComponent, SampleCheckbox, SingleTableBoxScene,
  TabTextLabel
} from "@/shared/components/ui";
import {
  BucketAwtENUM, RECURRENCIAS_CHOICE, ROUTER_PATHS, gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg6,
  gridSizeMdLg9,
  handleAxiosError, handleErrorForm,
  newProductoSchema, texto, useLoaders, useUploadFile
} from "@/shared";
import { Grid, } from "@mui/material";
import { useForm } from "react-hook-form";
import CustomNumberTextField from "@/shared/components/ui/CustomNumberTextField";
import { useCategoriaProductoStore } from "@/store/erp/shared/categoria-producto.store";
import {
  ErrorMessagesForm, IDataProducto, IVA, MARCASPRODUCTO,
  PROVEEDOR, Presentacion, ProductoForm, SubCategorias
} from "@/shared/interfaces";
import { useEffect, useState } from "react";
import { useCreateProducto, useFetchPutProducto } from "@/shared/actions/erp/producto.action";
import { useIvaStore } from "@/store/erp/shared/iva.store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { CATEGORYPRODUCT, MEDIDASPRODUCTOS, MODELOPRODUCTOS } from "@/shared/interfaces/erp/inventario";
import {
  useFetchMarcasProduct, useFetchMedidasProductos,
  useFetchModeloProductos, useFetchPresentacion, usefetchProveedor
} from "@/shared/actions/erp";
import { useFetchSubCategorias } from "@/shared/actions/erp/compras/subcategorias-productos.actions";
import ImageUploadComponente from "@/shared/components/ui/UploadImage/ImageUploadComponente";
import { useCatalogoPlanCuentaStore } from "@/store/erp/shared/catalogo-plan-cuenta.store";
import { useAuthStore } from "@/store/auth";
import PlanCuentaProductoComponente from "./PlanCuentaProductoComponente";
//import { url } from "inspector";

export type SaveInventariableProps = {
  titlePage: string;
  editInventario?: IDataProducto;
};

export default function SaveInventariable({
  titlePage,
  editInventario
}: SaveInventariableProps) {

  const empresa = useAuthStore(s => s.user?.empresa);
  const navigate = useNavigate();
  const { isLoadingIva, ivas } = useIvaStore();
  const createProducto = useCreateProducto();

  //const { idproducto } = useParams();

  //STATE
  const [imgProducto, setImgProducto] = useState<File | null>(null);
  const [imgProducto1, setImgProducto1] = useState<File | null>(null);
  const [urlImgProducto, setUrlImgProducto] = useState<string[]>([]);

  //fetch
  const { categoriaProductos, isLoadingCategoriaProducto } = useCategoriaProductoStore();
  const { data: modeloProductos, isLoading: isLoadingModeloProductos, } = useFetchModeloProductos({
    page_size: 600
  });
  const { data: marcaProductos, isLoading: isLoadingMarcaProductos } = useFetchMarcasProduct({
    page_size: 600
  });
  const { data: proveedor, isLoading: isLoadingProveedors } = usefetchProveedor({
    page_size: 600
  });
  const { data: medidaProductos, isLoading: isLoadingMedidaProductos } = useFetchMedidasProductos({
    page_size: 600
  });
  const { data: subCategorias, isLoading: isLoadingSubCategoria } = useFetchSubCategorias({
    page_size: 600
  });
  const { data: presentacion, isLoading: isLoadingPresentacion } = useFetchPresentacion({
    page_size: 600
  });

  /* const {
    data: productoAsociado,
    isLoading: isLoadingProductoAsociado
  } = useFetchProductos({
    params: {
      es_productor_factor: true,
      //estado: false
    }
  }) */

  const {
    isPending: isPendingPutProducto,
    mutateAsync: fetchPutProducto,
    isSuccess: isSuccessPutProduto
  } = useFetchPutProducto({});

  //Store
  const getCatalogoPlanCuenta = useCatalogoPlanCuentaStore(s => s.getCatalogoPlanCuenta);

  //HOOK
  const {
    handleUpdateFile,
    handleUploadFile,
  } = useUploadFile();

  //FORM
  const form = useForm<ProductoForm, any, ProductoForm>({
    resolver: yupResolver(newProductoSchema)
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;

  const onSubmit = async (e: ProductoForm) => {

    try {

      delete e.productos_asociados
      delete e.productos_asociados_data
      delete e.productos_asociados_factor_data


      e.precios = [
        {
          estado: true,
          nombre: 'Precio 1',
          precio: form.getValues().precio_1.toString(),
        },
        {
          estado: true,
          nombre: 'Precio 2',
          precio: form.getValues().precio_2.toString(),
        },
        {
          estado: true,
          nombre: 'Precio 3',
          precio: form.getValues().precio_3.toString(),
        },
      ]

      ///**cuanta contable */
      if (Array.isArray(e.cuentas_contables)) {
        const cuentaLista = e.cuentas_contables
          .map(c => c?.id)
          .filter((id): id is string => !!id); // elimina null/undefined

        // Si hay cuentas seleccionadas → enviamos
        if (cuentaLista.length > 0) {
          e.cuentas_contables = cuentaLista;
        }
        // Si el usuario borró todas → enviamos array vacío para borrar
        else {
          e.cuentas_contables = [];
        }
      }
      // Si no hay cambios y ya existían cuentas → mantenemos
      else if (editInventario?.cuentas_contables?.length) {
        e.cuentas_contables = editInventario.cuentas_contables;
      }
      // Si nunca hubo cuentas y no se tocó → eliminamos campo
      else {
        delete e.cuentas_contables;
      }

      ///* cuenta contables
      /* const cuentaLista = e.cuentas_contables?.map(e => e.id);
      e.cuentas_contables = cuentaLista ?? []; */
      //console.log('url', urlImgProducto)
      ///* editar inventariable

      if (editInventario) {
        // Clonamos las imágenes existentes, asegurando que siempre tenga 2 posiciones
        let urls_imagenes = [...(editInventario.urls_imagenes ?? ["", ""])];

        //  Imagen 1 ---
        if (imgProducto) {
          // Si hay archivo nuevo, actualiza o sube
          if (urls_imagenes[0]) {
            await handleUpdateFile(imgProducto, BucketAwtENUM.IMAGE_INVENTARIO, urls_imagenes[0]);
          } else {
            const imagen_1 = (await handleUploadFile(imgProducto, BucketAwtENUM.IMAGE_INVENTARIO)).url;
            urls_imagenes[0] = imagen_1;
          }
        } else if (!urlImgProducto[0]) {
          // Si fue borrada desde el componente
          urls_imagenes[0] = "";
        }

        // imagen 2
        if (imgProducto1) {
          if (urls_imagenes[1]) {
            await handleUpdateFile(imgProducto1, BucketAwtENUM.IMAGE_INVENTARIO, urls_imagenes[1]);
          } else {
            const imagen_2 = (await handleUploadFile(imgProducto1, BucketAwtENUM.IMAGE_INVENTARIO)).url;
            urls_imagenes[1] = imagen_2;
          }
        } else if (!urlImgProducto[1]) {
          urls_imagenes[1] = "";
        }


        urls_imagenes = [
          urls_imagenes[0] || "",
          urls_imagenes[1] || "",
        ];

        const dataActualizada = {
          ...e,
          urls_imagenes,
        };

        await fetchPutProducto({
          id: editInventario.id_producto,
          data: dataActualizada,
        });

        return;
      }



      /*  if (editInventario) {
         const urls_imagenes = [...(editInventario.urls_imagenes ?? [])].filter(url => !!url);
 
         if (imgProducto && urls_imagenes.length > 0) {
           await handleUpdateFile(imgProducto, BucketAwtENUM.IMAGE_INVENTARIO, urls_imagenes[0]);
         }
         if (imgProducto && urls_imagenes.length === 0) {
           const imagen_1 = (await handleUploadFile(imgProducto!, BucketAwtENUM.IMAGE_INVENTARIO)).url
           urls_imagenes.push(imagen_1)
         }
 
         if (imgProducto1 && urls_imagenes.length > 1) {
           await handleUpdateFile(imgProducto1, BucketAwtENUM.IMAGE_INVENTARIO, urls_imagenes[1]);
         } else {
           const imagen_2 = (await handleUploadFile(imgProducto1!, BucketAwtENUM.IMAGE_INVENTARIO)).url
           urls_imagenes.push(imagen_2)
         }
         console.log('urls_imagenes', urls_imagenes)
         const dataActualizada = {
           ...e,
           urls_imagenes,
         };
         await fetchPutProducto({
           id: editInventario.id_producto,
           data: dataActualizada
         })
         return
       } */


      ///* crear inventariable
      /*     return; */
      const imagen_1 = (await handleUploadFile(imgProducto!, BucketAwtENUM.IMAGE_INVENTARIO)).url;
      const imagen_2 = (await handleUploadFile(imgProducto1!, BucketAwtENUM.IMAGE_INVENTARIO)).url;

      e.urls_imagenes = [
        imagen_1, imagen_2
      ]
      await createProducto.mutateAsync(e);
    } catch {
    }

    /* if (editInventario) {
      if (imgProducto )
        await handleUpdateFile(imgProducto, BucketAwtENUM.IMAGE_INVENTARIO, editInventario?.urls_imagenes[0]!);
      if (imgProducto1)
        await handleUpdateFile(imgProducto1, BucketAwtENUM.IMAGE_INVENTARIO, editInventario?.urls_imagenes[1]!);
      return await fetchPutProducto({ id: editInventario.id_producto, data: e });
    } */

    //crear inventariable
    const imagen_1 = (await handleUploadFile(imgProducto!, BucketAwtENUM.IMAGE_INVENTARIO)).url;
    const imagen_2 = (await handleUploadFile(imgProducto1!, BucketAwtENUM.IMAGE_INVENTARIO)).url;

    e.urls_imagenes = [
      imagen_1, imagen_2
    ]
    await createProducto.mutateAsync(e);
  }


  useEffect(() => {
    if (!editInventario) return;

    try {
      getCatalogoPlanCuenta(empresa!);

      const precios = editInventario?.precios || [];

      // mapeamos los null a undefined
      const formData = {
        ...editInventario,
        precio_1: precios[0]?.precio ? Number(precios[0].precio) : 0,
        precio_2: precios[1]?.precio ? Number(precios[1].precio) : 0,
        precio_3: precios[2]?.precio ? Number(precios[2].precio) : 0,
        proveedor: editInventario.proveedor ?? undefined,
        es_ont: editInventario?.es_ont!
        // haz lo mismo para cualquier otra propiedad que pueda ser null
      };

      reset(formData);
      setUrlImgProducto(editInventario?.urls_imagenes || []);
    } catch (error) {
      handleAxiosError(error);
      navigate(ROUTER_PATHS.inventario.productosNav);
    }
  }, [editInventario]);




  /*  useEffect(() => {
   
     if (!editInventario) return;
   
     try {
   
       getCatalogoPlanCuenta(empresa!);
       const precios = editInventario.precios || []
       console.log('precios', )
       reset({...form.getValues(),})
       /* reset(editInventario as any)
       if (editInventario?.precios && editInventario?.precios.length === 4) {
         reset({
           ...form.getValues(),
           precio_1: +editInventario.precios[0].precio || 0,
          //precio_1: +editInventario?.precios[0].precio,
           precio_2: +editInventario?.precios[1].precio,
           precio_3: +editInventario?.precios[2].precio,
           //precio_4: +editInventario?.precios[3].precio
         })
       } */
  /* 
        setUrlImgProducto(editInventario?.urls_imagenes || []);
      } catch (error) {
        handleAxiosError(error)
        navigate(ROUTER_PATHS.inventario.productosNav)
      }
   
    }, [editInventario, isLoadingProductoAsociado]);  */

  useLoaders(isPendingPutProducto)

  if (isSuccessPutProduto) {
    return <LoaderComponent />
  }

  return (
    <SingleTableBoxScene
      title={titlePage}
      backPageUrl={ROUTER_PATHS.inventario.productosNav}
      enableBackBtn={true}
      enableCreateOrEditBtn={true}
      fnCreateOrEdit={handleSubmit(onSubmit, (error) => {
        /* console.log('e', error) */
        handleErrorForm(error as ErrorMessagesForm);
      })}
    >
      <Grid container spacing={3}>

        <Grid item xs={12}>
          <TabTextLabel text={'Información General'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>

        <CustomTextField
          control={control}
          name="codigo"
          defaultValue={form.getValues().codigo || ''}
          size={gridSizeMdLg6}
          label={texto.codigo}
          error={errors.codigo}
          helperText={errors.codigo?.message}
        />
        <CustomTextField
          size={gridSizeMdLg6}
          label="Descripción Producto"
          name="descripcion"
          control={form.control}
          defaultValue={form.getValues().descripcion || ''}
          error={errors.descripcion}
          helperText={errors.descripcion?.message}
          required={true}
        />
        <CustomTextField
          size={gridSizeMdLg6}
          label="Número Referencia Softnet"
          name="numero_referencia"
          control={form.control}
          defaultValue={form.getValues().numero_referencia || ''}
          error={errors.numero_referencia}
          helperText={errors.numero_referencia?.message}
          required={true}
        />

        <CustomAutocomplete<Presentacion>
          size={gridSizeMdLg6}
          label={texto.presentacion}
          name="presentacion"
          options={presentacion?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().presentacion || ''}
          isLoadingData={isLoadingPresentacion}
          control={control}
          error={errors.presentacion}
          helperText={errors.presentacion?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), presentacion: e });
          }}
        />
        <CustomAutocomplete<PROVEEDOR>
          size={gridSizeMdLg6}
          label={texto.proveedor}
          name="proveedor"
          options={proveedor?.data.data || []}
          valueKey="razon_social"
          actualValueKey="codigo"
          defaultValue={form.getValues().proveedor || ''}
          isLoadingData={isLoadingProveedors}
          control={control}
          error={errors.proveedor}
          helperText={errors.proveedor?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), proveedor: e });

          }}
        />
        <CustomAutocomplete<CATEGORYPRODUCT>
          size={gridSizeMdLg6}
          label={texto.categoria_producto}
          name="categoria_producto"
          actualValueKey="codigo"
          options={categoriaProductos || []}
          valueKey="nombre"
          defaultValue={form.getValues().categoria_producto || ''}
          isLoadingData={isLoadingCategoriaProducto}
          control={control}
          error={errors.categoria_producto}
          helperText={errors.categoria_producto?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), categoria_producto: e });

          }}
        />
        <CustomAutocomplete<SubCategorias>
          size={gridSizeMdLg6}
          label={texto.subcategoria_producto}
          name="subcategoria_producto"
          options={subCategorias?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().subcategoria_producto || ''}
          isLoadingData={isLoadingSubCategoria}
          control={control}
          error={errors.subcategoria_producto}
          helperText={errors.subcategoria_producto?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), subcategoria_producto: e });
          }}
        />
        <CustomAutocomplete<MARCASPRODUCTO>
          size={gridSizeMdLg6}
          label={texto.marca_producto}
          name="marca_producto"
          options={marcaProductos?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().marca_producto || ''}
          isLoadingData={isLoadingMarcaProductos}
          control={control}
          error={errors.marca_producto}
          helperText={errors.marca_producto?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), marca_producto: e });
          }}
        />

        <CustomAutocomplete<MODELOPRODUCTOS>
          size={gridSizeMdLg6}
          label={texto.modelo_producto}
          name="modelo_producto"
          options={modeloProductos?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().modelo_producto || ''}
          isLoadingData={isLoadingModeloProductos}
          control={control}
          error={errors.modelo_producto}
          helperText={errors.modelo_producto?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), modelo_producto: e });
          }}
        />
        <CustomAutocompleteArrString
          label={texto.recurrencia_compra}
          name="recurrencia_compra"
          options={RECURRENCIAS_CHOICE}
          control={form.control}
          defaultValue={form.getValues().recurrencia_compra || ''}
          error={errors.recurrencia_compra}
          helperText={errors.recurrencia_compra?.message?.toString() ?? ''}
          isLoadingData={false}
          size={gridSizeMdLg6}
        />
        <CustomAutocomplete<MEDIDASPRODUCTOS>
          size={gridSizeMdLg6}
          label={texto.unidad_producto}
          name="unidad_medida"
          options={medidaProductos?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().unidad_medida || ''}
          isLoadingData={isLoadingMedidaProductos}
          control={control}
          error={errors.unidad_medida}
          helperText={errors.unidad_medida?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), unidad_medida: e });
          }}
        />

        {/* {
          !isLoadingProductoAsociado && (
            <AcutocompletePromocion<IDataProducto>
              label="Productos asociados"
              name="productos_asociados"
              textFieldKey="productos_asociados"
              valueKey={"descripcion"}
              actualValueKey="codigo"
              //option
              options={productoAsociado?.data.data || []}
              defaultValue={
                !!editInventario?.productos_asociados?.length
                  ? productoAsociado?.data.data.filter((value: IDataProducto) => {
                    const dataDb = editInventario?.productos_asociados || [];

                    return dataDb.some(
                      (planDb: string) => planDb === value?.id_producto || planDb === value?.codigo
                    );
                  })
                  : []
              }
              isLoadingData={isLoadingProductoAsociado}
              error={!!errors.productos_asociados}
              control={form.control}
              helperText={errors.productos_asociados?.message}
              size={gridSizeMdLg6}
              onChangeRawValue={(e) => {
                form.setValue(
                  "productos_asociados",
                  e?.map((item) => item?.codigo!)
                );
              }}
            />
          )
        } */}

        <SampleCheckbox
          label="Usa metros"
          name="usa_metros"
          defaultValue={false}
          onChangeValue={(e) => {
            reset({
              ...form.getValues(),
              usa_metros: e
            })
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />

        {
          form.getValues().usa_metros && (
            <CustomNumberTextField
              control={control}
              name={"metros_base"}
              min={0}
              step={0.01}
              defaultValue={form.getValues().metros_base || ''}
              size={gridSizeMdLg6}
              label={'Metros base'}
              error={errors.metros_base}
              helperText={errors.metros_base?.message} />
          )
        }

        <Grid item xs={12}>
          <TabTextLabel text={'Precio y Costo'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>

        <CustomNumberTextField
          control={control}
          name={"precio_1"}
          min={0}
          step={0.01}
          defaultValue={form.getValues().precio_1 || ''}
          size={gridSizeMdLg6}
          label={texto.precio_1}
          error={errors.precio_1}
          helperText={errors.precio_1?.message} />

        <CustomNumberTextField
          control={control}
          name={"precio_2"}
          min={0}
          step={0.01}
          defaultValue={form.getValues().precio_2 || ''}
          size={gridSizeMdLg6}
          label={texto.precio_2}
          error={errors.precio_2}
          helperText={errors.precio_2?.message} />

        <CustomNumberTextField
          control={control}
          name={"precio_3"}
          min={0}
          step={0.01}
          defaultValue={form.getValues().precio_3 || ''}
          size={gridSizeMdLg6}
          label={texto.precio_3}
          error={errors.precio_3}
          helperText={errors.precio_3?.message} />
        <CustomNumberTextField
          control={control}
          name={"costo_actual"}
          min={0}
          step={0.01}
          defaultValue={form.getValues().costo_actual || ''}
          size={gridSizeMdLg6}
          label={texto.costo_actual}
          error={errors.costo_actual}
          helperText={errors.costo_actual?.message} />

        <CustomNumberTextField
          control={control}
          name={"costo_compra"}
          defaultValue={form.getValues().costo_compra || ''}
          size={gridSizeMdLg6}
          min={0}
          step={0.01}
          label={texto.costo_compra}
          error={errors.costo_compra}
          helperText={errors.costo_compra?.message} />

        <CustomNumberTextField
          control={control}
          min={0}
          step={0.01}
          name={"costo_promedio"}
          defaultValue={form.getValues().costo_promedio || ''}
          size={gridSizeMdLg6}
          label={texto.costo_promedio}
          error={errors.costo_promedio}
          helperText={errors.costo_promedio?.message}
        />

        <CustomAutocomplete<IVA>
          size={gridSizeMdLg6}
          label={texto.iva}
          name="iva"
          options={ivas || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={''}
          isLoadingData={isLoadingIva}
          control={control}
          error={errors.iva}
          helperText={errors.iva?.message}
          onChangeValue={(e) => {
            reset({ ...form.getValues(), iva: e });
          }}
        />
        {/*  <SwitchComponenteForm
            control={control}
            defaultValue={form.getValues().acepta_negativo || true}
            label={texto.acepta_negativos}
            name="acepta_negativo"
            size={gridSizeMdLg6}
          /> */}

        <Grid item xs={12}>
          <TabTextLabel text={'Stock'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>

        <CustomNumberTextField
          control={control}
          min={0}
          name={"stock_maximo"}
          defaultValue={form.getValues().stock_maximo || ''}
          size={gridSizeMdLg6}
          label={texto.stock_maximo}
          error={errors.stock_maximo}
          helperText={errors.stock_maximo?.message} />

        <CustomNumberTextField
          control={control}
          min={0}
          name={"stock_minimo"}
          defaultValue={form.getValues().stock_minimo || ''}
          size={gridSizeMdLg6}
          label={texto.stock_minimo}
          error={errors.stock_minimo}
          helperText={errors.stock_minimo?.message} />

        <CustomNumberTextField
          control={control}
          min={1}
          name={"stock_seguridad"}
          defaultValue={form.getValues().stock_seguridad || ''}
          size={gridSizeMdLg6}
          label={texto.stock_seguridad}
          error={errors.stock_seguridad}
          helperText={errors.stock_seguridad?.message}
        />
        <CustomNumberTextField
          label="Stock Actual"
          name="stock_actual"
          defaultValue={form.getValues().stock_actual || ''}
          control={control}
          error={errors.stock_actual}
          helperText={errors.stock_actual?.message}
          size={gridSizeMdLg6}
        />
        <Grid item xs={12}>
          <TabTextLabel text="Elegir las opciones" mt={0} pb={0} pl={0} pt={0} />
        </Grid>
        <Grid {...gridSizeMdLg12} container item>
          <SampleCheckbox
            label="Es ONT"
            name="es_ont"
            defaultValue={false}
            onChangeValue={(e) => {
              if(!e){
                form.setValue('service_profile', '');
              }
            }}
            control={form.control}
            size={gridSizeMdLg3}
          />
          {
            form?.watch()?.es_ont &&
            <CustomTextField
              size={gridSizeMdLg9}
              label="Service Profile"
              name="service_profile"
              control={form.control}
              defaultValue={form.getValues().service_profile || ''}
              error={errors.service_profile}
              helperText={errors.service_profile?.message}
              required={true}
            />
          }
        </Grid>
        <SampleCheckbox
          label="Es UTP"
          name="es_utp"
          defaultValue={false}
          onChangeValue={(e) => {
            console.log(e)
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />
        <SampleCheckbox
          label="Es VENTA"
          name="es_para_venta"
          defaultValue={false}
          onChangeValue={(e) => {
            console.log(e)
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />
        <SampleCheckbox
          label="Es FIBRA"
          name="es_fibra"
          defaultValue={false}
          onChangeValue={(e) => {
            console.log(e)
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />
        <SampleCheckbox
          label="Activo"
          name="estado"
          defaultValue={true}
          onChangeValue={(e) => {
            console.log(e)
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />

        <SampleCheckbox
          label="Producto factor"
          name="es_productor_factor"
          defaultValue={false}
          onChangeValue={(e) => {
            console.log(e)
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />

        <SampleCheckbox
          label="Tiene Serie"
          name="contiene_serie"
          defaultValue={true}
          onChangeValue={(e) => {
            console.log(e)
          }}
          control={form.control}
          size={gridSizeMdLg3}
        />

        <Grid item xs={12}>
          <TabTextLabel text={'Imagen'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>

        <Grid item {...gridSizeMdLg6}>
          <ImageUploadComponente
            idInput="producto-1-inventariable"
            enablePreview={true}
            buttonText={texto.imagen_producto_1}
            selectedImage={imgProducto}
            setSelectedImage={setImgProducto}
            imageUrl={urlImgProducto[0] || ''}
            onClickTrash={() => {
              const auxImagen1 = [...urlImgProducto]
              auxImagen1[0] = '';
              setUrlImgProducto(auxImagen1);
            }}
          />
        </Grid>

        <Grid item {...gridSizeMdLg6}>
          <ImageUploadComponente
            idInput="producto-2-inventariable"
            buttonText={texto.imagen_producto_2}
            selectedImage={imgProducto1}
            setSelectedImage={setImgProducto1}
            imageUrl={urlImgProducto[1] || ''}
            onClickTrash={() => {
              const auxImagen2 = [...urlImgProducto]
              auxImagen2[1] = '';
              setUrlImgProducto(auxImagen2);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TabTextLabel text={'Otros'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>
        {/* <CustomTextArea
          size={gridSizeMdLg6}
          label={texto.descripcion}
          name="descripcion"
          control={form.control}
          defaultValue={form.getValues().descripcion || ''}
          error={errors.descripcion}
          helperText={errors.descripcion?.message}
          required={false}
        /> */}
        <CustomTextArea
          size={gridSizeMdLg6}
          label="Observaciones"
          name="observaciones"
          control={form.control}
          defaultValue={form.getValues().observaciones}
          error={errors.observaciones}
          helperText={errors.observaciones?.message}
          required={false}
        />
        <Grid item xs={12}>
          <PlanCuentaProductoComponente
            form={form}
            key={'plan-cuenta-componente'}
          />
        </Grid>

      </Grid>



    </SingleTableBoxScene>
  );
}